<template>
  <section
    class="max-w-1440 w-full grid grid-cols-4 md:grid-cols-8 lg:grid-cols-12"
    :class="{ 'border-b border-black': withBorder }"
  >
    <section
      class="w-full flex flex-col items-center px-6 lg:px-0 pt-10 pb-12 lg:py-11 col-span-full md:col-start-2 md:col-end-8 lg:col-end-12"
    >
      <p
        class="uppercase text-3xl font-bold"
        v-text="'LOREM IPSUM DOLOR SIT AMET'"
      />
      <section class="grid lg:grid-cols-3 pt-12 gap-x-6">
        <member-card v-if="!isMobile" />
        <member-card />
        <member-card v-if="!isMobile" />
      </section>
    </section>
  </section>
</template>
<script>
import utilsMixin from "../mixins/utilsMixin";
export default {
  mixins: [utilsMixin],
  components: {
    MemberCard: () => import("../components/MemberCard.vue"),
  },
  props:{
    withBorder: {
      default: true
    }
  }
};
</script>
